// liste des médias
export enum RESOURCES {
  WIZEOO = './assets/logo/wizeoo.png',
  ALLKEYME = './assets/logo/allkeyme-white.svg',
}
